import { defineStore } from 'pinia'
import { useEditForm } from "@/stores/_helpers.js";
import { useForm } from "laravel-precognition-vue";
import * as Sentry from "@sentry/vue";

export const useAuthStore = defineStore('auth', {
  persist: {
    afterRestore: (context) => {
      context.store.setAxiosBearerToken();
    }
  },
  state: () => ({
    user: null,
    token: null,
  }),
  getters: {
    getUsername: (state) => state.user?.name,
    getInitials: (state) => {
      let parts = state?.user?.name?.split(' ');
      if (parts?.length === 1)
        return parts?.[0]?.[0];

      if (parts?.length === 2)
        return `${ parts?.[0]?.[0] }${ parts?.[1]?.[0] }`;

      return '-';
    },
    getEmail: (state) => state.user?.email,
    isLoggedIn: (state) => !!state.token && !!state.user,
  },
  actions: {
    async getLoginUserForm() {
      return useForm('post', 'auth/login', {email: null, password: null, two_fa_code: null})
    },
    async getForgotPasswordForm() {
      return useForm('post', 'auth/forgot-password', {email: null})
    },
    async getPasswordResetForm({ token, email }) {
      return useForm('post', 'auth/reset-password', {token, email, current_password: null, password: null, password_confirmation: null})
    },
    async loginUser({user, token}) {
      this.user = user;
      console.log(this.user);
      this.token = token;
      this.setAxiosBearerToken();
      Sentry.setUser({ id: user.id });
    },
    async logoutUser() {
      try {
        this.$reset();
        await axios.post('auth/logout');
        this.setAxiosBearerToken();
        Sentry.setUser({ id: null });
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async fetchUser() {
      try {
        const {data, token} = (await axios.post('auth/user')).data;
        this.user = data;
        this.token = token;
        this.setAxiosBearerToken();
      } catch (error) {
        this.$reset();
        this.setAxiosBearerToken();

        console.error(error.response);
        throw error.response;
      }
    },
    async editSelf(params = {}) {
      try {
        const response = await axios.get(`users/${ this.user.id }/edit`, { params });
        return useEditForm(`users/${ this.user.id }`, { ...response.data, current_password: null, password: null, password_confirmation: null});
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    setAxiosBearerToken() {
      if (this.token) {
        window.axios.defaults.headers.common['Authorization'] = `Bearer ${ this.token }`
      } else {
        window.axios.defaults.headers.common['Authorization'] = undefined;
      }
    },
    hasPermission(permission, matchAll = false) {
      let matchType = matchAll ? 'every' : 'some';
      let permissions = permission;

      if (typeof permissions === "string") {
        permissions = permission.split('|');
      }

      return !!permissions[matchType](p => this.user?.permissions?.includes(p));
    },
  },
});
